import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const BannersList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('banners'), link: '/banners-list' },
		{ title: t('list') }
	];

	const [banners, setBanners] = useState([]);
	let bannersListData = {
		head: [t('image'), t('type'), t('status'), t('operation')],
		body: banners.map(banner => [
			<img className="w-50 h-50" src={banner.banner_image} />,
			banner.banner_type === 1 ? t('home_page') : banner.banner_type === 2 ? t('notifications') : banner.banner_type === 3 ? t('portal') : banner.banner_type === 4 ? t('marketers_club') : banner.banner_type === 5 ? t('analysers_club') : banner.banner_type === 6 ? t('consultation') : banner.banner_type === 7 ? t('shop') : t('contests'),
			<span className={"badge rounded-pill p-2 badge-subtle-" + (banner.is_active ? 'success' : 'secondary')}>
				{banner.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/banners-edit/${banner.banner_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['', 'rtl', '', 'ltr']
	};

	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchBannerType, setSearchBannerType] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getBanners = async () => {
		let body = {
			banner_type: searchBannerType,
			is_active: null,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/banners/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_banners);
				setBanners(response.data.banners);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterBanners = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let type = event.target.searchBannerType.value.trim() || null;
		setSearchBannerType(type);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};

	const bannerTypesList = [
		{ key: t('home_page'), value: 1 },
		{ key: t('notifications'), value: 2 },
		{ key: t('portal'), value: 3 },
		{ key: t('marketers_club'), value: 4 },
		{ key: t('analysers_club'), value: 5 },
		{ key: t('consultation'), value: 6 },
		{ key: t('shop'), value: 7 },
		{ key: t('contests'), value: 8 }
	];
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getBanners();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('banners')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterBanners}>
						<div className="row gx-2">
							<FormField type="select" fieldKey="searchBannerType" title={t('type')} value={searchBannerType} selectItems={bannerTypesList} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('banners')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={bannersListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default BannersList;
